import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueAMap from 'vue-amap';

import '@/assets/fonts/iconfont.css';
import './plugins/element.js';

Vue.config.productionTip = false;

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '7851303c817dab33dfe1eeb1991ff3c4',
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.DistrictSearch',
    'AMap.DistrictLayer',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geolocation'
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
